// extracted by mini-css-extract-plugin
export default {"transparent":"TransparentBtn_transparent__GTLrX"};